'use client';

import { memo, useCallback, useMemo, useState } from 'react';

import { ImageIcon } from '@air/design-icons';

import { imgixLoader } from '~/utils/imgixLoader';

export type ListItemRowThumbnailProps = {
  alt: string;
  src?: string;
};

export const ListItemRowThumbnail = memo(({ alt, src }: ListItemRowThumbnailProps) => {
  const [imageError, setImageError] = useState(false);
  const optimizedSrc = useMemo(() => (src ? imgixLoader({ src, width: 80 }) : undefined), [src]);
  const showPlaceholder = !optimizedSrc || imageError;

  const handleImageError = useCallback(() => {
    setImageError(true);
  }, []);

  if (showPlaceholder) {
    return (
      <div className="flex size-8 shrink-0 items-center justify-center rounded-4 bg-neutral-4 text-neutral-8">
        <ImageIcon aria-hidden="true" size="sm" />
      </div>
    );
  }

  return (
    // biome-ignore lint/performance/noImgElement: External CDN image, not using Next.js Image
    <img
      alt={alt}
      className="size-8 shrink-0 rounded-4 object-cover"
      loading="lazy"
      onError={handleImageError}
      src={optimizedSrc}
    />
  );
});

ListItemRowThumbnail.displayName = 'ListItemRowThumbnail';
